import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import SystemComponentOutageLocalizationResponse from "./systemComponentOutageLocalizationResponse";
import SystemComponentOutageState from "./systemComponentOutageState";
import LanguageCode from "./languageCode";
import { getCustomOutage, setCustomOutage } from "../utils/customOutage";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class SystemComponentOutageResponse {
  id!: string;

  @observable
  isDeleted!: boolean;

  @observable
  description?: string;

  @observable
  @Type(() => SystemComponentOutageLocalizationResponse)
  systemComponentOutageLocalizations?: SystemComponentOutageLocalizationResponse[];

  @observable
  @Type(() => Date)
  validSince!: Date;

  @observable
  @Type(() => Date)
  validUntil?: Date;

  @observable
  @Type(() => Date)
  visibleSince!: Date;

  @observable
  @Type(() => Date)
  visibleUntil?: Date;

  @observable
  systemComponentId!: string;

  @observable
  systemComponentOutageState!: SystemComponentOutageState;

  @observable
  _validSinceTime?: string;

  @observable
  _validUntilTime?: string;

  @observable
  _visibleSinceTime?: string;

  @observable
  _visibleUntilTime?: string;

  @observable
  _systemComponentCode?: string;
}

export default class SystemComponentOutage extends SystemComponentOutageResponse {
  @computed
  get until() {
    return this.validUntil;
  }

  set until(date: Date | undefined) {
    this.validUntil = date;
    this.visibleUntil = date;
  }

  @computed get customOutageCs() {
    return getCustomOutage({ languageCode: LanguageCode.Cs, localizations: this.systemComponentOutageLocalizations });
  }

  set customOutageCs(description: string) {
    this.systemComponentOutageLocalizations = setCustomOutage({
      description,
      languageCode: LanguageCode.Cs,
      localizations: this.systemComponentOutageLocalizations,
    });
  }

  @computed get customOutageEn() {
    return getCustomOutage({ languageCode: LanguageCode.En, localizations: this.systemComponentOutageLocalizations });
  }

  set customOutageEn(description: string) {
    this.systemComponentOutageLocalizations = setCustomOutage({
      description,
      languageCode: LanguageCode.En,
      localizations: this.systemComponentOutageLocalizations,
    });
  }
}
